export default "__VITE_ASSET__scMy2tVn__"